import { useRef } from "react";

import styled from "styled-components/macro";

import extendedFieldHooks from "ExtendedFields/selectorHooks";

import useScrollTo from "Utilities/Hooks/useScrollTo";

import AddFieldSelect from "./AddFieldSelect/AddFieldSelect";
import ExtendedFieldNav from "./ExtendedFieldNav/ExtendedFieldNav";
import FieldEditor from "./FieldEditor/FieldEditor";

const ScreenSplitter = styled("div")`
  display: flex;
  flex-direction: row;
`;

const ScreensFlexContainer = styled("div")`
  overflow-y: auto;
  flex-basis: 200%;
  padding: 20px;
`;

const FullUI = () => {
  const [isEditing] = extendedFieldHooks.useIsEditing();
  const flexContainerRef = useRef();
  const [fieldId] = extendedFieldHooks.useSelectedFieldId();

  useScrollTo({
    scrollElementRef: flexContainerRef,
    scrollTrigger: fieldId,
  });

  return (
    <ScreenSplitter data-cy="ExtendedFields_FullUI">
      <ExtendedFieldNav />
      <ScreensFlexContainer ref={flexContainerRef}>
        <div>
          {!isEditing && (
            <div>
              <AddFieldSelect />
            </div>
          )}
          {isEditing && (
            <div>
              <FieldEditor />
            </div>
          )}
        </div>
      </ScreensFlexContainer>
    </ScreenSplitter>
  );
};

export default FullUI;
